import { useSelector } from "react-redux";
import {
  Header,
  InfoIcon,
  LineDivider,
  PriceItem,
  StickyContainer,
  Title,
  Wrapper,
} from "./style";
import { normalizePrice } from "../../../utils";
import { CashbackBadge } from "../../ui";
import i18next from "i18next";

const round = value => Math.round(value * 100) / 100;

const PriceComponent = () => {
  const { t } = i18next;

  const { currency } = useSelector(state => state.appConfigs);

  const {
    totalPrice,
    fare,
    taxes,
    partnerFees,
    clientFees,
    cashback,
    cashbackCurrency,
  } = useSelector(state => state.prebook);

  const total = totalPrice?.[currency] || 0;

  const taxesAmount = taxes?.[currency] || 0;

  const knownFees =
    (partnerFees?.[currency] || 0) +
    (clientFees?.[currency] || 0);

  // Базовый тариф
  const fareAmount =
    fare?.[currency] ??
    round(total - taxesAmount - knownFees);

  // Сервисный сбор
  const serviceFee = round(
    total - fareAmount - taxesAmount
  );

  // Таксы + сборы = таксы + сервисный сбор
  const taxesAndFees = round(
    taxesAmount + serviceFee
  );

  return (
    <StickyContainer>
      <Wrapper>
        <Header>
          <Title>{t("to_pay_title")}</Title>
        </Header>

        {/* Базовый тариф */}
        <PriceItem $isSmallText>
          <span>{t("base_fare")}:</span>

          <span>
            {normalizePrice(fareAmount.toFixed(2))} {currency}
          </span>
        </PriceItem>

        {/* Таксы и сборы = таксы + сервисный сбор */}
        {taxesAndFees > 0 && (
          <PriceItem $isSmallText>
            <span>
              {t("taxes_and_fees")}{" "}
              <InfoIcon title={t("includes_service_charges")}>
                ⓘ
              </InfoIcon>
            </span>

            <span>
              {normalizePrice(taxesAndFees.toFixed(2))} {currency}
            </span>
          </PriceItem>
        )}

        <LineDivider />

        {/* Итого */}
        <PriceItem>
          <span className="price__footer">
            {t("total")}:
          </span>

          <span className="total__amount">
            {normalizePrice(total.toFixed(2))} {currency}
          </span>
        </PriceItem>

        {/* кэшбек b2c — бейдж под итогом (0 / выключен — не рисуется) */}
        <CashbackBadge amount={cashback} currency={cashbackCurrency || currency} />
      </Wrapper>
    </StickyContainer>
  );
};

export default PriceComponent;